<sp-add-vantaca-credential *ngIf="isVantaca" [formGroup]="credentialsFormGroup"></sp-add-vantaca-credential>

<sp-add-cinc-credential *ngIf="isCinc" [formGroup]="credentialsFormGroup"></sp-add-cinc-credential>

<sp-add-appfolio-credential *ngIf="isAppFolio" [formGroup]="credentialsFormGroup"></sp-add-appfolio-credential>

<sp-add-eunify-credential *ngIf="isEUnify" [formGroup]="credentialsFormGroup"></sp-add-eunify-credential>

<footer class="text-end">
  <button type="button" class="btn btn-cancel" (click)="onCancel()">Cancel</button>
  <button type="button" class="btn btn-success" [disabled]="!credentialsFormGroup?.valid"
      (click)="onAddCredential()">Add</button>
</footer>